import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { CircularProgress, CircularProgressProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface LoadingSpinnerTsoPqProps extends Omit<CircularProgressProps, 'color'> {
  color?: string;
}

const StyledCircularProgress = styled(CircularProgress)({
  color: tsoPqTheme.palette.background.primary.color_primary_background_bg_prim_enabled,
});

const LoadingSpinnerTsoPq = ({ color, ...props }: LoadingSpinnerTsoPqProps) => {
  return <StyledCircularProgress {...props} />;
};

export default LoadingSpinnerTsoPq;
